import React, { forwardRef, useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { Grid, FormControl, InputLabel, MenuItem, Typography, CircularProgress, Select, TextField, LinearProgress, Box } from '@material-ui/core'
import Dropzone from '../../../components/lab/DropZone'
import ComunicacaoControleService from "../../../services/ComunicacaoControleService"
import { useSnackbar } from "notistack"
import { useEffect } from 'react'
import webconfig from "../../../webconfig.json"

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

export default function ReciboResposta({ idOrgaoJurisdicionado, reciboResposta, setReciboResposta, setRecarregarComunicacoes }) {
    const handleFecharReciboResposta = () => {
        limpaCamposReciboResposta();
        setReciboResposta({
            open: false,
            controle: {}
        })
    }

    const [files, setFiles] = useState([]);
    const [progressoUploadArquivo, setProgressoUploadArquivo] = useState({
        emProgresso: false,
        porcentagem: 0
    });

    const [observacaoResposta, setObservacaoResposta] = useState('');
    const [tipoDeResposta, setTipoDeResposta] = useState(0);
    const handleTipoDeResposta = (event) => {
        setTipoDeResposta(event.target.value);
    }

    const [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const quantidadeMaximaDeArquivos = 100;
    const tamanhoMaximoBytesPorArquivo = 209215200; // ~199.5MB (margem para o cabeçalho multipart não estourar o limite de 200MB do servidor)

    const limpaCamposReciboResposta = () => {
        setLoading(false);
        setTipoDeResposta(0);
        setObservacaoResposta('');
    }

    useEffect(() => {
    }, [reciboResposta.open])

    const salvaReciboResposta = async () => {

        if (observacaoResposta === null || observacaoResposta === '') {
            enqueueSnackbar(`É necessário informar as observações da resposta.`, { variant: "warning", autoHideDuration: webconfig.snackbarAutoHideDuration })
            return;
        }

        if (files.length === 0) {
            enqueueSnackbar(`É necessário anexar pelo menos um arquivo.`, { variant: "warning", autoHideDuration: webconfig.snackbarAutoHideDuration })
            return;
        }

        for (let i = 0; i < files.length; i++) {
            if (files[i].size > tamanhoMaximoBytesPorArquivo) {
                enqueueSnackbar(`É permitido fazer upload com arquivos de no máximo ${(tamanhoMaximoBytesPorArquivo / 1024 / 1024).toFixed(0)} MB.`, { variant: "warning", autoHideDuration: webconfig.snackbarAutoHideDuration })
                return;
            }
        }

        setLoading(true);

        try {
            let arquivosAnexos = [];
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                let formData = new FormData();
                var tipoAquivo = file.name.substr(file.name.lastIndexOf('.') + 1, file.name.length);
                formData.append(tipoAquivo, file);

                const responseUpload = await ComunicacaoControleService.UploadAnexoReciboResposta(formData);
                const idAnexo = responseUpload.data;

                let arqAnexo = {
                    id: idAnexo,
                };

                arquivosAnexos.push(arqAnexo);

                setProgressoUploadArquivo({
                    emProgresso: true,
                    porcentagem: Math.round(((i + 1) / files.length) * 100)
                });
            }

            let recibo = {
                tipo: tipoDeResposta,
                observacao: encodeURIComponent(observacaoResposta),
                Arquivos: arquivosAnexos
            };

            enqueueSnackbar(`Arquivos enviados. Gerando o comprovante do recibo, aguarde...`, { variant: "info", autoHideDuration: webconfig.snackbarAutoHideDuration });
            debugger;
            const response = await ComunicacaoControleService.SalvaReciboResposta(idOrgaoJurisdicionado, reciboResposta.controle.id, recibo);

            if (response.status === 200) {
                setProgressoUploadArquivo({ emProgresso: true, porcentagem: 100 });
                enqueueSnackbar(`Recibo e anexos enviados com sucesso.`, { variant: "success", autoHideDuration: webconfig.snackbarAutoHideDuration });
                limpaCamposReciboResposta();
                setReciboResposta({
                    open: false,
                    controle: {}
                });

                let dataAtual = new Date();
                setRecarregarComunicacoes(dataAtual.toString());
            } else {
                enqueueSnackbar(`${response.data}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration });
            }
        } catch (error) {
            if (error.response && error.response.data) {
                if (error.response.status === 422) {
                    const validacao = JSON.parse(error.response.data.detail);
                    let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
                    for (let i = 0; i < validacao.Validacoes.length; i++) {
                        var itemValidado = validacao.Validacoes[i];
                        for (var propriedadeValidada in itemValidado) {
                            mensagem += itemValidado[propriedadeValidada];
                        }
                        if ((i + 1) < validacao.Validacoes.length) {
                            mensagem += "; ";
                        }
                    }
                    enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration });
                }
                else if (error.response.status === 500) {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration });
                }
                else {
                    enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration });
                }
            }
            else {
                enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration });
            }
        } finally {
            setLoading(false);
            setProgressoUploadArquivo({
                emProgresso: false,
                porcentagem: 0
            });
        }
    }

    useEffect(() => {
        if (reciboResposta.open) {
            setProgressoUploadArquivo({
                emProgresso: false,
                porcentagem: 0
            })
        }
    }, [reciboResposta, setProgressoUploadArquivo])

    return (
        <Dialog
            open={reciboResposta.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => loading ? null : handleFecharReciboResposta()}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            id="dialog-padrao"
        >
            <DialogTitle id="alert-dialog-slide-title" className="txt-primario">Enviar Resposta</DialogTitle>
            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                        <FormControl variant="outlined">
                            <InputLabel id="select-outlined-label-prioridade" shrink>Tipo de Resposta</InputLabel>
                            <Select
                                labelId="select-outlined-label-prioridade"
                                id="select-outlined-prioridade"
                                value={tipoDeResposta}
                                onChange={handleTipoDeResposta}
                                disabled={loading}
                            >
                                <MenuItem value={0}>Resposta</MenuItem>
                                <MenuItem value={1}>Outros (Informações/Solicitações)</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <FormControl>
                            <TextField
                                variant="outlined"
                                type="text"
                                label="Observações da resposta*"
                                multiline={true}
                                minRows={6}
                                maxRows={15}
                                value={observacaoResposta}
                                inputProps={{ maxLength: 2000 }}
                                onChange={item => setObservacaoResposta(item.target.value)}
                                placeholder="Digite aqui suas observações referente ao envio da resposta"
                                disabled={loading}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant='caption' style={{ paddingBottom: 25, color: 'var(--red)' }}><strong>Somente é permitido o tamanho máximo de {(tamanhoMaximoBytesPorArquivo / 1024 / 1024).toFixed(0)} MB por arquivo.</strong></Typography>
                        <Dropzone disabled={loading} files={files} setFiles={setFiles} clear={reciboResposta.open} maxFiles={quantidadeMaximaDeArquivos} maxSizePerFile={tamanhoMaximoBytesPorArquivo} />
                        {progressoUploadArquivo.emProgresso && (
                            <Box mt={2}>
                                <Typography variant="body2" color="textSecondary">{`Enviando arquivo(s): ${progressoUploadArquivo.porcentagem}%`}</Typography>
                                <LinearProgress variant="determinate" value={progressoUploadArquivo.porcentagem} />
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={loading} onClick={() => handleFecharReciboResposta()} className="bg-alternativo-4 txt-alternativo-3">Cancelar</Button>
                <Button
                    className="bg-primario txt-branco btn-salvar-default"
                    onClick={() => loading ? ('') : salvaReciboResposta()}
                    style={{ float: "inline-end" }}>
                    {
                        loading
                            ?
                            <CircularProgress size={22} />
                            :
                            'Enviar'
                    }
                </Button>
            </DialogActions>
        </Dialog>
    )
}